// extracted by mini-css-extract-plugin
export default {"sortable":"app-react-components-datatables-TableHeaderCell-module__sortable","sortingActive":"app-react-components-datatables-TableHeaderCell-module__sortingActive"};